import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OrgaoJulgadorColegiadoLocalListaComponent } from './orgao-julgador-colegiado-local-lista/orgao-julgador-colegiado-local-lista.component';
import {OrgaoJulgadorColegiadoLocalVisualizacaoComponent} from './orgao-julgador-colegiado-local-visualizacao/orgao-julgador-colegiado-local-visualizacao.component';

const routes: Routes = [
  { path: 'orgaoJulgadorColegiadoLocal/listar', component: OrgaoJulgadorColegiadoLocalListaComponent, data: { titulo: 'Lista os órgãos julgadores colegiados' }  },
  { path: 'orgaoJulgadorColegiadoLocal/visualizar/:id', component: OrgaoJulgadorColegiadoLocalVisualizacaoComponent, data: { titulo: '´Visualização de  órgão julgador' }  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OrgaoJulgadorColegiadoLocalRoutingModule { }

